import { Component, ElementRef, EventEmitter, Input, OnInit, AfterViewInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { Table } from 'primeng/table';
import { environment } from '../../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';

@Component({
  selector: 'app-make-i-benchmark',
  standalone: false,
  templateUrl: './make-i-benchmark.component.html',
  styleUrls: ['./make-i-benchmark.component.scss']
})
export class MakeIBenchmarkComponent implements OnInit, AfterViewInit {
  @Input() id: any;
  benchmarkForm: FormGroup;
  tecDataHeader: any[] = [];
  tecData: any[] = [];
  payload: any;
  isEditMode: boolean = false;
  existingBenchmarkId: any = null;
  @Input() step: any;
  @Input() schemeType: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() routeConfig = new EventEmitter<any>();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @ViewChild('table') table: Table;
  benchmarkData: any;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  vendors: any;
  apiUrl = environment.APIUrl;
  JustificationForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  resId: any;
  vendorForm!: FormGroup;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  userID: any;
  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {
    this.benchmarkForm = this.fb.group({
      benchmark_price: ['', Validators.required],
      comment: ['', Validators.required],
      bid_opening_date: [''],
      bid_opening_time: [''],
      technical_bid_venue: [''],
    });
    this.vendorForm = this.fb.group({
      vendor_name: ['', Validators.required],
      vendor_address: ['', Validators.required],
      benchmark_price: [null, [Validators.required, Validators.min(0)]],
      bid_opening_date: [''],
      bid_opening_time: [''],
      document: [null]
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.payload = {
        proposal_id: params['id'],
        proposal_name: params['name']
      };
      this.fetchBenchmarkData();
    });
  }
  ngAfterViewInit() {
    // setTimeout(() => {
    //   if (this.stepDetails?.can_edit) {
    //     this.isEditorDisabled = false;
    //     this.benchmarkForm.enable();
    //   } else {
    //     this.isEditorDisabled = true;
    //     this.benchmarkForm.disable();
    //   }
    // }, 3000);
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  addRow() {
    const newRow: any = { editable: true };
    this.tecDataHeader.forEach(header => newRow[header.key] = '');
    this.tecData.unshift(newRow);
  }

  fetchBenchmarkData() {
    this.api.getAPI(`/make1/benchmark-details/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`).subscribe({
      next: (res) => {
        if (res) {
          this.vendors = res[0]?.vendors
          this.benchmarkForm.patchValue({
            comment: res[0]?.justification || res?.justification ||'',
            benchmark_price: res[0]?.base_price || res?.base_price || '',
            bid_opening_date: res[0]?.bid_opening_date || res?.bid_opening_date  || '',
            bid_opening_time: res[0]?.bid_opening_time || res?.bid_opening_time || '',
            technical_bid_venue: res[0]?.technical_bid_venue || res?.technical_bid_venue || ''
          });
          this.resId = res[0]?.id || res?.id
          console.log("checking id ", this.resId);
          // sessionStorage.setItem('benchmark', res[0]?.base_price)
          const basePrice = res?.base_price || res[0]?.base_price;
          sessionStorage.setItem('benchmark', String(basePrice));
          // Load benchmark dates
         if (res?.benchmarkmake_dates && Array.isArray(res.benchmarkmake_dates)) {
            this.benchmarkDates = res.benchmarkmake_dates.map((row: any) => ({
              ...row,
              edit: false
            }));
          } else {
          this.benchmarkDates = [];
        }
        }
      }
    })
  }

  onFileUpload(event: any, rowData: any): void {
    const file = event.target.files[0];
    if (file) {
      rowData.uploadedFile = file;
      rowData.uploadedFileName = file.name;
    }
  }

  selectedFiles: any
  onFileSelect(event: any,) {
    const file = event.files[0];
    if (file) {
      this.selectedFiles = file;

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `File attached successfully`
      });
    }
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }

  showAddDialog: boolean = false;
  editIndex: number | null = null;

  newVendor: any = {
    vendor: { name: '', address: '' },
    benchmarkPrice: null,
    document: null,
    file: null
  };

  selectedVendor: any
  onEditVendor(row: any, index: number) {
    this.isEditMode = true;
    this.editIndex = index;
    this.selectedVendor = row
    this.vendorForm.patchValue({
      document: row.document,
      vendor_name: row.vendor_name,
      vendor_address: row.vendor_address,
      benchmark_price: row.benchmark_price,
      bid_opening_date: row.bid_opening_date,
      bid_opening_time: row.bid_opening_time,
      vendorId: row.vendor_id
    }
    );
    this.vendorForm.get('document')?.setValue(row.document);

    this.showAddDialog = true;
  }

  onNewVendorFileUpload(event: any) {
    const file = event.target.files[0];
    const maxSizeBytes = 200 * 1024 * 1024; // 200 MB

    if (file.size > maxSizeBytes) {
      this.messageService.add({
        severity: 'error',
        summary: 'File Too Large',
        detail: `Maximum allowed file size is 200MB.`,
      });
      event.target.value = '';
      return;
    }
    if (file) {
      this.vendorForm.patchValue({ document: file });
      this.vendorForm.get('document')?.setValue(file);
    }
  }
  showAddDialogPopup() {
    this.vendorForm.reset();
    this.vendorForm.value.document = null
    this.vendorForm.value.name = '';
    this.vendorForm.get('document')?.setValue(null);
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    this.showAddDialog = true;
  }
  submitVendor() {
    const formData = new FormData();

    formData.append('proposal_step', this.step.id);
    formData.append('vendor_name', this.vendorForm.value.vendor_name);
    formData.append('vendor_address', this.vendorForm.value.vendor_address);
    formData.append('benchmark_price', this.vendorForm.value.benchmark_price);
    formData.append('bid_opening_date', this.vendorForm.value.bid_opening_date);
    formData.append('bid_opening_time', this.vendorForm.value.bid_opening_time);
    formData.append('single_vendor', "true");

    if (this.vendorForm.value.document instanceof File) {
      formData.append('document', this.vendorForm.value.document);
    }

    if (this.selectedVendor) {
      formData.append('vendor_id', this.selectedVendor.id);
    }

    const request$ = this.selectedVendor?.id
      ? this.api.putAPI(`/make1/benchmark-details/${this.resId}/`, formData)
      : this.api.postAPI('/make1/benchmark-details/', formData);

    request$.subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Vendor saved successfully' });
        this.showAddDialog = false;
        this.fetchBenchmarkData();
        this.vendorForm.reset();
        this.vendorForm.get('document')?.setValue(null);
        this.vendorForm.value.document = null
        this.vendorForm.value.name = ''
        if (this.fileInput) {
          this.fileInput.nativeElement.value = '';
        }
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save vendor' });
      }
    });
  }

  resetVendorForm() {
    this.newVendor = {
      vendor: { name: '', address: '' },
      benchmarkPrice: null,
      document: null,
      file: null
    };
    this.showAddDialog = false;
    this.isEditMode = false;
    this.editIndex = null;
  }

  submitProposalData() {
    const payload: any = {
      proposal_step: this.step.id,
      base_price: this.benchmarkForm.get('benchmark_price')?.value,
      bid_opening_date: this.benchmarkForm.get('bid_opening_date')?.value,
      bid_opening_time: this.benchmarkForm.get('bid_opening_time')?.value,
      technical_bid_venue : this.benchmarkForm.get('technical_bid_venue')?.value,
      justification: this.benchmarkForm.get('comment')?.value,
       benchmark_dates: this.benchmarkDates.map(row => ({
        name: row.name || '',
        date: row.date || ''
      }))
    };

    if (this.resId) {
      this.api.putAPI(`/make1/benchmark-details/${this.resId}/`, payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Submitted successfully' });
          this.fetchBenchmarkData();
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to submit' });
        }
      });
    } else {
      this.api.postAPI(`/make1/benchmark-details/`, payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Submitted successfully' });
          this.fetchBenchmarkData();
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to submit' });
        }
      });
    }
  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Comments", value: this.benchmarkForm.get('comment')?.value },
      ]
    };
    this.generatePDFEmitter.emit(payload);
  }

  // onSave() {
  //   this.submitProposalData();
  //   this.routeConfig.emit({isRouteConfig: true});
  // }
  benchmarkDates: any[] = [];
addBenchmarkDateRow() {
    if (!this.benchmarkDates) {
      this.benchmarkDates = [];
    }
    this.benchmarkDates.push({ 
      sequence: '', 
      name: '', 
      date: '', 
      edit: true 
    });
  }

  saveBenchmarkDateRow(row: any) {
    // Validate required fields
    if (!row.name || !row.date) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Name and Date are required fields'
      });
      return;
    }

    // Check if this is an update (row has id) or create (new row)
    if (row.id) {
      // Update existing record
      const payload = {
        name: row.name,
        date: row.date
      };
      
      this.api.putAPI(`/make1/benchmark-dates/${row.id}/`, payload).subscribe({
        next: (res: any) => {
          row.edit = false; // Exit edit mode
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Benchmark date updated successfully'
          });
          this.fetchBenchmarkData(); // Refresh data
        },
        error: (err) => {
          console.error('Error updating benchmark date:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || err?.error?.message || 'Failed to update benchmark date'
          });
        }
      });
    } else {
      // Create new record
      if (!this.resId) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Benchmark details not found. Please save the main form first.'
        });
        return;
      }

      const payload = {
        benchmark: this.resId,
        name: row.name,
        date: row.date
      };

      this.api.postAPI('/make1/benchmark-dates/', payload).subscribe({
        next: (res: any) => {
          row.edit = false; // Exit edit mode
          // Update the row with the returned id
          if (res.id) {
            row.id = res.id;
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Benchmark date created successfully'
          });
          this.fetchBenchmarkData(); // Refresh data
        },
        error: (err) => {
          console.error('Error creating benchmark date:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || err?.error?.message || 'Failed to create benchmark date'
          });
        }
      });
    }
  }
}

